import { defineComponent } from 'vue'

export default defineComponent({
    name: "topup-number",
    template: '#topup-number',
    props: {
        countryPhonePrefix: String,
        country: String
    },
    computed: {
        formAction() {
            return "/p/topup_" + this.country.toLowerCase();
        }
    }
});